import React from 'react'
import Layout from '../../components/LayoutNew'
import { graphql, useStaticQuery } from 'gatsby'
import HomeSection3 from '../../containers/HomeSection3'
import ProductSection1 from '../../containers/ProductSection1'
import ProductSection2 from '../../containers/ProductSection2'
import Img from 'gatsby-image'

import './contentPlatform.scss'

const ContentPlatformPage = () => {
  const pageColor = '#1950FF'
  const { pic1, pic2, pic3 } = useStaticQuery(graphql`
    query {
      pic1: file(
        relativePath: { eq: "systemProduct/contentPlatform/neirong-01.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic2: file(
        relativePath: { eq: "systemProduct/contentPlatform/neirong-02.png" }
      ) {
        id
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic3: file(
        relativePath: { eq: "systemProduct/contentPlatform/neirong-03.png" }
      ) {
        id
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Layout
      className="contentPlatform-page"
      headerBackground={pageColor}
      headerTheme="white"
    >
      <ProductSection1
        className="section-0"
        background={pageColor}
        title="达人营销解决方案"
        subTitle="达人服务涵盖全网主要新兴媒体平台，为商户提供基于抖音、快手、小红书、B站等新兴媒体解决方案，为达人提供从报名到履约的一站式服务，帮助达人商家有效撮合。"
      />
      <ProductSection2
        id="contentPlatform-1"
        className="section-1"
        title="达人一站式服务平台"
        subTitle="达人一站式服务平台，提供达人从报名到履约的一站式服务，帮助达人便捷的找到各主流平台商家需求。"
        image={
          <div style={{ width: '562px' }}>
            <Img fluid={pic1.childImageSharp.fluid} alt="达人推荐" />
          </div>
        }
      />
      {/* <ProductSection2
        id="contentPlatform-2"
        className="section-2"
        type="row-reverse"
        title="自动视频剪辑"
        subTitle="再惠自动剪辑系统由再惠一碗MCN团队联合技术团队共同打造，上传用户拍摄的原始素材可一键生成专业的探店视频，迅速积累人气。"
        image={
          <div style={{ width: '487px' }}>
            <Img fluid={pic2.childImageSharp.fluid} alt="自动视频剪辑" />
          </div>
        }
      /> */}
      {/* <ProductSection2
        id="contentPlatform-3"
        className="section-3"
        title="账号运营策略"
        subTitle="作为本地生活行业头部MCN机构，拥有多年达人运营经验。商户授权账号后，系统根据账号运营情况自动给出运营建议。"
        image={
          <div style={{ width: '487px' }}>
            <Img fluid={pic3.childImageSharp.fluid} alt="账号运营策略" />
          </div>
        }
      /> */}
      <HomeSection3 />
    </Layout>
  )
}

export default ContentPlatformPage
